'use client'

import Image from 'next/image'

export default function HeroDecorations() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none select-none" aria-hidden="true">
      {/* Blob 1 - Sol üst */}
      <div className="absolute -top-20 -left-20 w-[400px] h-[400px] animate-float-slow opacity-90">
        <Image
          src="/images/decorations/blob-1.svg"
          alt=""
          fill
          className="object-contain"
          priority
        />
      </div>
      
      {/* Blob 2 - Sağ üst */}
      <div className="absolute -top-10 -right-16 w-[350px] h-[350px] animate-float-medium opacity-85">
        <Image
          src="/images/decorations/blob-2.svg"
          alt=""
          fill
          className="object-contain"
          priority
        />
      </div>
      
      {/* Blob 3 - Sol alt */}
      <div className="absolute bottom-20 -left-10 w-[300px] h-[300px] animate-pulse-soft opacity-80 hidden md:block">
        <Image
          src="/images/decorations/blob-3.svg"
          alt=""
          fill
          className="object-contain"
        />
      </div>
      
      {/* Blob 2 (tekrar) - Sağ alt */}
      <div className="absolute bottom-32 -right-20 w-[280px] h-[280px] animate-float-slow opacity-75 hidden lg:block">
        <Image
          src="/images/decorations/blob-2.svg"
          alt=""
          fill
          className="object-contain"
        />
      </div>
      
      {/* Circle scatter overlay */}
      <div className="absolute inset-0 opacity-60">
        <Image
          src="/images/decorations/circle-scatter.svg"
          alt=""
          fill
          className="object-cover"
        />
      </div>
      
      {/* Geometric pattern overlay */}
      <div className="absolute inset-0 opacity-50 hidden md:block">
        <Image
          src="/images/decorations/geometric-pattern.svg"
          alt=""
          fill
          className="object-cover"
        />
      </div>
      
      {/* Hafif grid pattern */}
      <div 
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(59,130,246,1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(59,130,246,1) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
        }}
      />
    </div>
  )
}
